import React from 'react';
import { Navigate, useLocation } from 'react-router';

import { ThankYouContainer } from '@containers/thankYou/ThankYouContainer';
import { useAppDispatch, useCustomNavigate } from '@hooks';
import { cartActions } from '@store';

export const ThankYouPage = () => {
  const navigate = useCustomNavigate();
  const dispatch = useAppDispatch();
  const { state } = useLocation();

  if (!state || !state.fromCheckout || !state.orderNumber) {
    return <Navigate to="/" />;
  }

  dispatch(cartActions.clearCart());

  const onGoBack = () => navigate('/');

  return (
    <ThankYouContainer orderNumber={state.orderNumber} onGoBack={onGoBack} />
  );
};
